/**
 *
 * FormField
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import "./style.scss";
import { Button } from '../Buttons';

const EditableValueContainer = styled.div`
  display:flex;
`

const Required = styled.div`
  font-size: 14px;
  color: red;
`;

export function FormFields(props){
  return <div className={`formFields  ${props.narrow ? 'narrow' : ''}`}>{props.children}</div>
}

/* eslint-disable react/prefer-stateless-function */
export class FormField extends React.PureComponent {
  render() {

    let label = this.props.label ? <div className="label">{this.props.label} {this.props.subLabel  ? <div className="sub-label">{this.props.subLabel}</div>  : null}</div> : '';

    return <>
      <div className={
      ` formField ${ this.props.className || '' } ${this.props.error ? 'error' : ''} ${label ? '' : 'noLabel'} ${this.props.horizontal ? 'horizontal' : 'vertical'} ${this.props.center ? 'center' : ''} `}
        onClick={this.props.onClick}
        
      >{label}
     <div className="form-controlField">{this.props.children}</div></div>
      {this.props.required && <Required>* required</Required> }
    </>
  }
}


export class EditableValue extends  React.PureComponent {
  render() {
    return (
      <EditableValueContainer onClick={this.props.onEdit} className="editablevalue-container">
        {this.props.children} <Button/>
      </EditableValueContainer>
    )
  }
}

EditableValue.propTypes = {
  onEdit : PropTypes.func.isRequired
};
